import React from 'react';
import { useSelector } from 'react-redux';
import Course from 'components/prism/course';

export const InProgressCourses = ({ text, data }) => {
    const { prismMultiColumn } = useSelector(state => state.ui);

    return (
        <>
            <h2 className="mb10">{text.inprogress} 
                <span className="ml10" style={{ fontWeight: 400 }}>
                    {data?.length}
                </span>
            </h2>        
            <div className={prismMultiColumn ? 'even-col' : ''}>
                {data.map(item => (
                    <Course key={`course-${item.id}`} course={item} padBottom={!prismMultiColumn} />
                ))}
            </div>
        </>
    );
};

export default InProgressCourses;
